module.exports = __webpack_public_path__ + "static/media/arborea3.f600ac62.webp";